export default {
  fulfillmentPacking: 'Fulfillment packing',
  fulfillmentPackingCreate: 'Pack consolidation',
  fulfillmentPackingStatus: 'Packing',
  fulfillmentPackedQuantity: 'Packed {packed} of {total}',
  fulfillmentPackingAlgorithm: 'Fulfillment packing instructions',
  fulfillmentPackingStepScan: 'Scan or manually enter the fulfillment barcode.',
  fulfillmentPackingStepCargo: 'Scan or manually enter the cargo barcode and click Done.',
  fulfillmentPackingStepPallet: 'To group cartons on a pallet, select the cartons and click Add cartons to pallet.',
  fulfillmentPackingStepComplete: 'Once all parcels are packed, click Complete assignment. The scanned quantities will be added to the consolidation and marked Packed.',
  fulfillmentPackingRetryHint: 'The operation outcome could not be confirmed. Retry it before continuing.',
  fulfillmentPackingRetry: 'Retry operation',
  fulfillmentPackingRequestFailed: 'The request failed. Check your connection and try again.',
  fulfillmentPackingAddToPallet: 'Add cartons to pallet',
  fulfillmentPackingCompletionHint: 'At least one filled carton is required. Filled cartons must have a size and cargo barcode. Empty cartons will be removed.',
  fulfillmentPackingNoBoxes: 'Add a carton to start scanning.',
  fulfillmentPackingCargoRequired: 'Enter a cargo barcode',
  fulfillmentPackingDetachPallet: 'Remove carton from pallet',
  fulfillmentPackingScan: 'Scan parcels',
  fulfillmentPackingBarcode: 'Fulfillment barcode',
  fulfillmentPackingCargoBarcode: 'Cargo barcode',
  fulfillmentPackingSummary: 'Cartons used',
  fulfillmentPackingBoxCount: 'Carton count',
  fulfillmentPackingBox: 'Carton',
  fulfillmentPackingRemoveUnit: 'Remove one unit',
  fulfillmentPackingDeleteBox: 'Delete the carton and its scanned quantities? Inventory stock will not change.',
  fulfillmentPackingRefresh: 'Refresh',

  close: 'Close',
};
